export const BASE_MAP_STYLE: any = {
  version: 8,
  sources: {
    osm: {
      type: 'raster',
      tiles: [
        'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
        'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
        'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png',
      ],
      tileSize: 256,
      attribution: '&copy; OpenStreetMap contributors',
    },
    nexrad: {
      type: 'raster',
      tiles: ['https://mesonet.agron.iastate.edu/cache/tile.py/1.0.0/nexrad-n0q-900913/{z}/{x}/{y}.png'],
      tileSize: 256,
      attribution: '&copy; NOAA/NWS',
    },
  },
  layers: [
    {
      id: 'osm-base',
      type: 'raster',
      source: 'osm',
      minzoom: 0,
      maxzoom: 19,
    },
    {
      id: 'nexrad-overlay',
      type: 'raster',
      source: 'nexrad',
      minzoom: 0,
      maxzoom: 19,
      paint: {
        'raster-opacity': 0.72,
      },
    },
  ],
};

export function getMapStyle(theme = document.body.dataset.theme) {
  return theme === 'light' ? 'mapbox://styles/mapbox/light-v11' : 'mapbox://styles/mapbox/dark-v11';
}
